import { render, staticRenderFns } from "./DogDetails.vue?vue&type=template&id=6c562734"
import script from "./DogDetails.vue?vue&type=script&lang=ts"
export * from "./DogDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports